/**
 * Injects brand CSS custom properties into :root at app startup.
 * All Tailwind `primary-*` classes and Vuetify theme colors resolve through these vars,
 * so swapping brand.config.js and rebuilding is enough to retheme the whole app.
 */
import brand from '@/config/brand'

export function applyBrand() {
  const root = document.documentElement

  // Inject primary color palette as CSS variables
  const primary = brand.colors.primary
  Object.entries(primary).forEach(([shade, value]) => {
    root.style.setProperty(`--color-primary-${shade}`, value)
  })

  // Font family
  root.style.setProperty('--font-family', brand.fontFamily)

  // Auth page decorative panel background color
  root.style.setProperty('--color-auth-panel', brand.authPanelColor || primary['900'])

  // Document direction for RTL support
  root.setAttribute('dir', brand.rtl ? 'rtl' : 'ltr')
  root.setAttribute('lang', brand.defaultLanguage)

  // Favicon — swap at runtime so builds don't need to rename files
  const favicon = document.querySelector("link[rel='icon']")
  if (favicon) favicon.setAttribute('href', brand.favicon)
}
